import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import audioFile from './sounds/beepbeep.mp3'
import Workout from './Workout';
import Lockr from 'lockr';
import registerServiceWorker from './registerServiceWorker';

function getWorkout()
{
    return Lockr.get('workout');
}

function updateWorkout(workout)
{
    Lockr.set('workout', workout);
}

ReactDOM.render(<Workout audio={new Audio(audioFile)} workout={getWorkout()} updateWorkout={updateWorkout} />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js